import { Container, ContainerMax } from './styles'

export const LayoutFull: React.FC = ({ children }) => {
  return (
        <ContainerMax>
            <Container>{children}</Container>
        </ContainerMax>
  )
}
